import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import FilterWithTrashed from '../filters/FilterWithTrashed';
import FilterOnlyTrashed from '../filters/FilterOnlyTrashed';

const DeletedSalesFilterModal = ({ show, handleClose, getPageItems }) => {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>O'chirilgan sotuvlar filtrlari</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-4">
                    <h6 className="mb-3">O'chirilgan sotuvlar bilan ishlash:</h6>
                    <div className="mb-3">
                        <FilterWithTrashed getPageItems={getPageItems} />
                        <small className="text-muted d-block mt-1">
                            Barcha sotuvlarni o'chirilganlar bilan birga ko'rsatish
                        </small>
                    </div>
                    
                    <div className="mb-3">
                        <FilterOnlyTrashed getPageItems={getPageItems} />
                        <small className="text-muted d-block mt-1">
                            Faqat o'chirilgan sotuvlarni ko'rsatish
                        </small>
                    </div>
                </div>
                
                <div className="alert alert-info">
                    <small>
                        <strong>Eslatma:</strong> Bu filtrlar bir-birini bekor qiladi. Agar ikkala filtr ham yoqilgan bo'lsa, oxirgi tanlangan filtr ishlatiladi.
                    </small>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Yopish
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeletedSalesFilterModal; 